// Wandelt die Lesbarkeits-Einstellungen einer Praxis in CSS-Klassen/-Styles um.
// Wird sowohl im Patienten-Kiosk als auch in der Admin-Mobile-Vorschau verwendet.
export const DEFAULT_DISPLAY = { font_size: "base", justify: false, hyphenate: false };

const SIZE_MAP = {
  base: "text-base sm:text-[17px]",
  lg: "text-lg sm:text-xl",
  xl: "text-xl sm:text-2xl",
};

export function docTextStyle(ds) {
  const s = ds || DEFAULT_DISPLAY;
  const sizeClass = SIZE_MAP[s.font_size] || SIZE_MAP.base;
  const style = {};
  if (s.justify) style.textAlign = "justify";
  if (s.hyphenate) {
    style.hyphens = "auto";
    style.WebkitHyphens = "auto";
    style.MozHyphens = "auto";
  }
  return { sizeClass, style, lang: s.hyphenate ? "de" : undefined };
}
